import { useMemo } from 'react';
import { useAssistantTool } from '@assistant-ui/react';
import { useHistory } from 'react-router-dom';
import { DASHBOARD_ASSISTANT_RUNTIME_MODE } from '../constants';
import { hasPermission, restrictedResult } from '../lib/permissions';
import { EMPTY_TOOL_PARAMETERS } from '../lib/assistantToolSchemas';
import {
  createFrontendNavigationToolMessage,
  createFrontendToolErrorMessage,
} from '../lib/toolActionMessages';

export function useDashboardNavigationAction({
  description,
  dispatchActionMessage,
  examples,
  name,
  path,
  permission,
}) {
  const history = useHistory();

  const tool = useMemo(
    () => ({
      toolName: name,
      type: 'frontend',
      description: `${description} Example phrases: ${examples.join(', ')}.`,
      parameters: EMPTY_TOOL_PARAMETERS,
      execute: () => {
        if (!hasPermission(permission)) {
          const result = restrictedResult(path);
          dispatchActionMessage?.(createFrontendToolErrorMessage({
            message: result.message,
            status: result.status,
            toolName: name,
            toolResult: result,
          }));
          return result;
        }

        history.push(path);
        const result = { runtimeMode: DASHBOARD_ASSISTANT_RUNTIME_MODE, status: 'opened', path };
        dispatchActionMessage?.(createFrontendNavigationToolMessage({
          path,
          toolName: name,
          toolResult: result,
        }));
        return result;
      },
    }),
    [description, dispatchActionMessage, examples, history, name, path, permission],
  );

  useAssistantTool(tool);
}
